import { render, staticRenderFns } from "./16.8Record.vue?vue&type=template&id=659b82ec&scoped=true&"
import script from "./16.8Record.vue?vue&type=script&lang=js&"
export * from "./16.8Record.vue?vue&type=script&lang=js&"
import style0 from "./16.8Record.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./16.8Record.vue?vue&type=style&index=1&id=659b82ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659b82ec",
  null
  
)

export default component.exports